if (document.getElementById('page-entry')) {
  const multistep = document.querySelector('input[type="hidden"][name="_cf7msm_multistep_tag"]')
  if (multistep) {
    const json = JSON.parse(multistep.value)

    if (json.hasOwnProperty('next_url')) {
      json.next_url = hUrl + json.next_url
      multistep.value = JSON.stringify(json)
    }
  }

  const note = document.querySelector('textarea[name="note"]')
  if (note) {
    const text = [
      `特になければ「なし」と記載してください。
新卒入社をご希望の方はWeb説明会のご希望参加日時をこちらにご記入ください。
質問などございましたら、お気軽にご記入ください。
なお、弊社を知った理由で以下を選択された方は、恐れ入りますが、備考欄に詳細のご入力をお願いいたします。
・当社社員による紹介：紹介者の氏名
・その他：差支えなければ、応募のきっかけをご教示いただけますでしょうか？ `,

      `特になければ「なし」と記載してください。
質問などございましたら、お気軽にご記入ください。
なお、弊社を知った理由で以下を選択された方は、恐れ入りますが、備考欄に詳細のご入力をお願いいたします。
・当社社員による紹介：紹介者の氏名
・その他：差支えなければ、応募のきっかけをご教示いただけますでしょうか？ `,
    ]

    const adjustPlaceholder = () => {
      const apply_type = document.querySelector('input[name="apply_type"]:checked')
      const placeholder = apply_type && apply_type.value == '新卒採用' ? text[0] : text[1]
      note.placeholder = placeholder
    }

    document.querySelectorAll('input[name="apply_type"]').forEach((item) => {
      item.addEventListener('change', adjustPlaceholder)
    })

    adjustPlaceholder()
  }
}
